import React, { useRef } from "react";
import {
  Grid,
  Paper,
  Box,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import OrderDetailsFetcher from "./OrderDetails/OrderData/OrderDetailsFetcher";
import ProductBrowser from "./OrderDetails/ProductBrowser/ProductBrowesrMain";
import InvoiceCreator from "./OrderDetails/InvoiceCreator/InvoiceCreatorMain";

const DeliveryModalContent = ({
  type,
  tableId,
  rootId,
  onSuccess,
  onClose,
  onOrderDeleted,
  orderId,
  open,
}) => {
  const reloadDetailsRef = useRef(null);
  const navigate = useNavigate();
  const scrollBoxRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleScrollDown = () => {
    if (scrollBoxRef.current) {
      scrollBoxRef.current.scrollTop = scrollBoxRef.current.scrollHeight;
    }
  };
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog
      open={open || false}
      onClose={handleClose}
      fullWidth
      maxWidth="xl" // ✅ تغيير من "lg" إلى "xl" (أكبر حجم)
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 3,
          bgcolor: "#1e1e2f",
          color: "#fff",
          height: isMobile ? "100vh" : "90vh", // ✅ زيادة الارتفاع إلى 90% من ارتفاع الشاشة
          maxHeight: "90vh", // ✅ الحد الأقصى للارتفاع
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#232334",
        }}
      >
        إدارة الطلب
        <IconButton
          onClick={handleClose}
          sx={{ color: "#EA7C69" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: { xs: 1, sm: 2 }, bgcolor: "#1e1e2f" }}>
        <Grid
          container
          spacing={{ xs: 1, sm: 2 }}
          sx={{
            flexDirection: { xs: "column-reverse", md: "row" },
            alignItems: "stretch",
            mt: 0,
          }}
        >
          {/* Left Section - Product Browser */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              order: { xs: 2, md: 1 },
              mb: { xs: 2, md: 0 },
              display: "flex",
              flexDirection: "column",
            }}
          >
            {type === "addItem" && orderId && (
              <ProductBrowser
                orderId={orderId}
                onSuccess={() => {
                  if (typeof reloadDetailsRef.current === "function") {
                    reloadDetailsRef.current();
                  }
                }}
              />
            )}
          </Grid>

          {/* Right Section - Order Details */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              order: { xs: 1, md: 2 },
              mb: { xs: 2, md: 0 },
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Paper
              sx={{
                p: { xs: 1, sm: 2 },
                bgcolor: "#1e1e2f",
                color: "#fff",
                height: "100%",
                minHeight: { xs: "auto", md: "400px" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden",
                position: "relative",
                border: "1px solid #333",
              }}
            >
              <Box
                ref={scrollBoxRef}
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  minHeight: 0,
                  maxHeight: { xs: 600, md: "calc(100vh - 200px)" },
                  pr: 1,
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": { display: "none" },
                }}
              >
                {orderId && (
                  <>
                    <OrderDetailsFetcher
                      orderId={orderId}
                      onReload={(fn) => (reloadDetailsRef.current = fn)}
                      onClose={handleClose}
                      onOrderDeleted={onOrderDeleted}
                    />

                    <InvoiceCreator
                      orderId={orderId}
                      onSuccess={() => {
                        if (onSuccess) onSuccess();
                        handleClose();
                        navigate("/delivery");
                      }}
                    />
                  </>
                )}
              </Box>
              {/* زر النزول للأسفل */}
              <Box
                sx={{
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  zIndex: 10,
                  bgcolor: "#232334",
                  borderRadius: "50%",
                  boxShadow: 2,
                }}
              >
                <IconButton
                  size="large"
                  color="primary"
                  onClick={handleScrollDown}
                  sx={{
                    bgcolor: "#fbc2eb",
                    color: "#232334",
                    "&:hover": { bgcolor: "#ff9a9e" },
                    width: 40,
                    height: 40,
                  }}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DeliveryModalContent;

